import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API, TOKEN_KEY } from "../lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (!t) return setUser(false);
    axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${t}` } })
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem(TOKEN_KEY); setUser(false); });
  }, []);
  const login = async (email, password) => {
    const r = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, r.data.token);
    setUser(r.data.user);
  };
  const logout = async () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
    axios.post(`${API}/auth/logout`).catch(() => {});
  };
  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);

export const RequireAdmin = ({ children }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="p-10 text-slate-600">Vérification de la session…</div>;
  if (!user) return <Navigate to="/admin/login" replace state={{ from: loc.pathname }} />;
  return children;
};
